import { Card } from '@aws-amplify/ui-react';
import { useContext } from 'react';
import UniversalTag from '../custom-components/UniversalTag';
import { GlobalContext, GlobalContextProps } from '../global-context';
import General from '../utils/GeneralUtils';
import './Profile.scss';

export function Profile(props: any) {
  const globalContext = useContext(GlobalContext);
  General.setTitle(document, 'Profile', globalContext);

  return <GlobalContext.Consumer>
    {
      (globalContextProps: GlobalContextProps) => <>
        <div className="content content-1000">
          <h2>Profile</h2>
          <Card variation='outlined' className="profile__card">
            <div className="profile__row"><span className="profile__label">First Name</span> { globalContextProps.authInfo?.userAttributes?.given_name }</div>
            <div className="profile__row"><span className="profile__label">Last Name</span> { globalContextProps.authInfo?.userAttributes?.family_name }</div>
            <div><span className="profile__label">Email</span> { globalContextProps.authInfo?.userAttributes?.email } { globalContextProps.authInfo?.userAttributes?.email_verified === 'true'
              ? <UniversalTag category='VERIFIED' />
              : <UniversalTag category='NOT_VERIFIED' />
            }</div>
          </Card>

          <h4 style={{ marginTop: 30 }}>Permissions</h4>
          <Card variation='outlined' className="profile__card">
            <div className="profile__row">
              <span className="profile__label">Role</span>
              <UniversalTag category={globalContextProps.authInfo?.role || 'MEMBER'} />
            </div>
            <div className="profile__row" style={{ display: 'flex' }}>
              <span className="profile__label">Permissions</span>
              {globalContextProps.authInfo?.permissions?.length ? (
                <span style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
                  {globalContextProps.authInfo.permissions.map((perm: string) => (
                    <span key={perm} className="desc-13" style={{ margin: 0 }}>{perm}</span>
                  ))}
                </span>
              ) : (
                <span>None</span>
              )}
            </div>
          </Card>
        </div>
      </>
    }
  </GlobalContext.Consumer>
}
